module.exports = __webpack_public_path__ + "img/05.2756eea1.jpg";